import { setSelectors, addListeners, formatMoney } from './utilities.js';
import { request, getCart } from '@umbrella/cart-service';

class RcCartSummary extends HTMLElement {

	constructor() {
		super();
		this.events = {};
		this._isUpdating = false;
		this.selectors = {};
		this._onCartSignal = this._onCartSignal.bind(this);
	};

	connectedCallback() { this.initialize(); };

	disconnectedCallback() { this.deinitialize(); };

	_onCartSignal(event) { this._refreshFromCart(); };

	async _refreshFromCart(){
		if(this._isUpdating || !this.selectors.summary) return;
		this._isUpdating = true;
		try {
			const U = window.umbrellaConfig || {};
			const cart = await request('/cart.js');
			const subtotal = cart && typeof cart.items_subtotal_price === 'number' ? cart.items_subtotal_price : 0;
			const total = cart && typeof cart.total_price === 'number' ? cart.total_price : 0;
			if(this.selectors.subtotal) this.selectors.subtotal.textContent = formatMoney(subtotal);
			if(this.selectors.total) this.selectors.total.textContent = formatMoney(total);
			// Refresh discount label markup via section rendering so Liquid logic stays source-of-truth
			const discountsEl = this.selectors.discounts;
			if(discountsEl){
				try {
					const html = await getCart('cart-summary-discounts');
					const tmp = document.createElement('div');
					tmp.innerHTML = html;
					const fresh = tmp.querySelector('[data-cart-summary-discounts]');
					if(fresh){
						// Replace inner content and mirror visibility classes
						discountsEl.innerHTML = fresh.innerHTML;
						discountsEl.className = fresh.className;
					} else {
						discountsEl.innerHTML = '';
						discountsEl.classList.add('hidden');
					};
				} catch(err2){
					if(U && U.devMode) console.warn('rc-cart-summary: failed to refresh discounts section', err2);
				};
			};
		} catch(err) {
			const U = window.umbrellaConfig || {};
			if(U && U.devMode) console.warn('rc-cart-summary: failed to update from cart', err);
		} finally {
			this._isUpdating = false;
		};
	};

	initialize(){
		const U = window.umbrellaConfig || {};
		this.events = U.events || {};
		this.selectors = setSelectors(this, {
			summary: '[data-cart-summary]',
			subtotal: '[data-cart-summary-subtotal]',
			total: '[data-cart-summary-total]',
			notice: '[data-cart-summary-notice]',
			delivery: '[data-cart-summary-delivery]',
			discounts: '[data-cart-summary-discounts]'
		});
		addListeners(document, {
			[this.events.cartChange]: this._onCartSignal,
			[this.events.cartAdded]: this._onCartSignal,
			[this.events.cartItemUpdated]: this._onCartSignal,
			[this.events.cartItemRemoved]: this._onCartSignal,
			[this.events.cartCleared]: this._onCartSignal,
			[this.events.quantityIncrement]: this._onCartSignal,
			[this.events.quantityDecrement]: this._onCartSignal,
			[this.events.discountApplied]: this._onCartSignal
		});
	};

	deinitialize(){
		const evs = this.events || {};
		const doc = document;
		if(evs.cartChange) doc.removeEventListener(evs.cartChange, this._onCartSignal);
		if(evs.cartAdded) doc.removeEventListener(evs.cartAdded, this._onCartSignal);
		if(evs.cartItemUpdated) doc.removeEventListener(evs.cartItemUpdated, this._onCartSignal);
		if(evs.cartItemRemoved) doc.removeEventListener(evs.cartItemRemoved, this._onCartSignal);
		if(evs.cartCleared) doc.removeEventListener(evs.cartCleared, this._onCartSignal);
		if(evs.discountApplied) doc.removeEventListener(evs.discountApplied, this._onCartSignal);
	};

};

if(!customElements.get('rc-cart-summary')) customElements.define('rc-cart-summary', RcCartSummary);